import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

import login from "../src/components/public_pages/login";
import demo from "../src/components/public_pages/demo";
import unauthorized from "../src/components/public_pages/unauthorizedPage";
import confirm from "../src/components/public_pages/confirm";
import forgetPassword from "../src/components/public_pages/forgetPassword";
import resetPassword from "../src/components/public_pages/resetPassword";
import step1 from "../src/components/public_pages/register/step1";
import step2 from "../src/components/public_pages/register/step2";
import step3 from "../src/components/public_pages/register/step3";
import mollieFirstPaymentConfirm from '../src/components/mollie/firstPaymentConfirm.vue'

import layout from "../src/components/layout/layout";

import backend from "./backend"

//import emailtemplate from "../src/components/settings/emailtemplate";
//import createemailtemplate from "../src/components/settings/createemailtemplate";
Vue.use(Router);

const router=new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes:[
        {
            path:"/demo",
            name:'demo',
            component:demo,
        },
        {
            path:"/login",
            name:'login',
            component:login,
        },
        {
            path:"/confirm/:customerId",
            name:'confirm',
            component:confirm,
        },
        {
            path:"/forgot-password",
            component:forgetPassword,
        },
        {
            path:"/reset-password/:token",
            component:resetPassword,
        },
        {
            path:"/register",
            component:step1,
        },
        {
            path:"/register-community",
            component:step2,
        },
        {
            path:"/registration-finish",
            component:step3,
        },
        {
            path:"/",
            component:layout,
            children:backend,
            meta:{
                AuthRequired:true
            },
        },
        {
            path:"/mollie/confirm/firstpayment/:status",
            name:'mollie-firstpayment-confirm',
            component:mollieFirstPaymentConfirm,
        },
        {
            path:"/access-denied",
            name:'unauthorized',
            component:unauthorized,
        },
            
        //
        // {
        //     path:'/emailtemplate',
        //     name:'emailtemplate',
        //     component:createemailtemplate,
        //
        // }

    ]
});

router.beforeEach((to,from,next)=>{
    if(to.matched.some(record => record.meta.AuthRequired)) {
        if(!store.state.auth.authenticated) {
            next({name:'login'})
            return
        } else {
            let roles = (to.meta && to.meta.roles) ? to.meta.roles : null
            
            let permissions = (to.meta && to.meta.permissions) ? to.meta.permissions : null
            let checkOwner = (to.meta && to.meta.checkOwner) ? to.meta.checkOwner : null
            let checkCanEdit = (to.meta && to.meta.checkCanEdit) ? to.meta.checkCanEdit : null
            let id = to.params.id ?? null;
            let hasAccess = userHasAccess(roles, permissions, checkOwner, id, checkCanEdit)
            
            if(hasAccess) {
                next();
            } else {
                next({name:'unauthorized'})
            }

        }
    }

    next();
})

function userHasAccess(roles, permissions, checkOwner, id, checkCanEdit) {
    if(store.getters.userRolesName.includes('Super-Admin')) return true;
    
    if(roles == null && permissions == null) return true;

    let hasAccess = false;
    if(roles != null) {
        
        for(let i = 0; i < roles.length; i++) {
            if(store.getters.userRolesName.includes(roles[i])) {
                hasAccess = true; 
                break;
            }
        }
        if(hasAccess) return true;
    }
    
    if(permissions != null) {
        for(let i = 0; i < permissions.length; i++) {
            if(store.getters.userPermissionsName.includes(permissions[i])) {
                hasAccess = true; 
                break;
            }
        }
        if(hasAccess) return true;
    }
    let checkIfUserIsOwner = !hasAccess && checkOwner && id && store.state.auth.user.id == id;
    
    if(checkIfUserIsOwner && checkCanEdit && !(process.env.VUE_APP_USER_CAN_EDIT_OWN_PROFILE == 1)) hasAccess = false;

    if(checkIfUserIsOwner) hasAccess = true

    return hasAccess;
    
}

export default router;
